module.exports = __webpack_public_path__ + "img/emoji_mostly cloudy.388d7f08.png";